import React from 'react'

import { ConfirmationDialog } from '@scoir/modals'
import { useDispatch } from 'react-redux'

import api from 'common/api'
import { actions as snactions } from 'store/snackbar'

type Props = {
  show: boolean
  inviterId: string
  onClose: () => void
  onDismiss: () => void
}

const DismissInviteModal = ({ show, inviterId, onClose, onDismiss }: Props) => {
  const [hasError, setHasError] = React.useState(false)
  const dispatch = useDispatch()
  const internalClose = () => {
    hasError && setHasError(false)
    onClose()
  }

  const dismissInvite = () => {
    api
      .post<{ inviterId: string }, any>(`/api/student/relate/reject`, { inviterId })
      .then(() => {
        onDismiss()
        internalClose()
      })
      .catch(() => {
        setHasError(true)
        dispatch(snactions.addSnackbarItem(`Failed to reject invite, please try again later.`))
      })
  }

  return (
    <ConfirmationDialog
      open={show}
      headerText="Reject invite?"
      onClose={() => onClose()}
      onConfirm={() => dismissInvite()}
      confirmationText="Yes, Reject"
    >
      If you dismiss this invite, you won't be able to collaborate with your parent/guardian.
    </ConfirmationDialog>
  )
}

export default DismissInviteModal
